module.exports = __webpack_public_path__ + "img/phone.0ab949a.svg";